import { useState, useCallback } from "react"
import { Avatar, Menu, Text, Divider } from "@mantine/core"
import { useDisclosure } from "@mantine/hooks"
import { useTranslation } from "react-i18next"
import { useUser } from "../hooks/useUser"
import { TwoFactorDialog } from "../pages/TwoFactorSetupPage"

export default function UserMenu() {
  const { t } = useTranslation()
  const { data: userData } = useUser()
  const user = userData?.user
  const avatarUrl = userData?.avatar_url || null
  const fullName = userData?.full_name || ""
  const [loggingOut, setLoggingOut] = useState(false)
  const [imgError, setImgError] = useState(false)
  const [twoFAOpened, { open: openTwoFA, close: closeTwoFA }] = useDisclosure(false)
  const showImage = avatarUrl && !imgError

  const displayName = fullName || user?.username || ""

  const handleLogout = useCallback(async () => {
    setLoggingOut(true)
    try {
      await fetch("/auth/logout", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
      })
    } catch {
      // ignore
    }
    window.location.href = "/"
  }, [])

  const show2FASetup = user && user.two_fa_type !== "authenticator"

  return (
    <>
      <Menu
        position="bottom-end"
        width={260}
        shadow="md"
        withArrow
        arrowOffset={12}
        offset={4}
        closeOnClickOutside
        closeOnEscape
      >
        <Menu.Target>
          <button
            type="button"
            className="flex items-center gap-2 bg-transparent border-0 p-0 cursor-pointer"
            aria-label={t("userMenu.open", { defaultValue: "User menu" })}
          >
            <Avatar
              src={showImage ? avatarUrl : undefined}
              radius="xl"
              size={32}
              alt={displayName}
              color="blue"
              onError={() => setImgError(true)}
            >
              {showImage ? undefined : <i className="fa fa-user" style={{ fontSize: 14, color: "#fff" }} />}
            </Avatar>
            <Text size="sm" c="white" className="hidden-xs">
              {displayName}
            </Text>
          </button>
        </Menu.Target>

        <Menu.Dropdown>
          <Menu.Label>
            <Text size="xs" fw={500} c="dimmed">
              {displayName}
            </Text>
            {user?.email && (
              <Text size="xs" c="dimmed">
                {user.email}
              </Text>
            )}
          </Menu.Label>

          <Divider />

          {show2FASetup ? (
            <Menu.Item
              leftSection={<i className="fa fa-shield" style={{ fontSize: 14, color: "#3b82f6" }} />}
              onClick={openTwoFA}
            >
              <Text size="sm">{t("userMenu.configure2FA", { defaultValue: "Configurar 2FA" })}</Text>
            </Menu.Item>
          ) : (
            <Menu.Item disabled leftSection={<i className="fa fa-check-circle" style={{ fontSize: 14, color: "#22c55e" }} />}>
              <Text size="sm">{t("userMenu.twoFAActive", { defaultValue: "2FA Autenticador Ativo" })}</Text>
            </Menu.Item>
          )}

          <Menu.Item
            color="red"
            leftSection={<i className="fa fa-sign-out" style={{ fontSize: 14 }} />}
            onClick={handleLogout}
            disabled={loggingOut}
          >
            <Text size="sm">{t("userMenu.logout", { defaultValue: "Sair" })}</Text>
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>

      {show2FASetup && <TwoFactorDialog opened={twoFAOpened} onClose={closeTwoFA} />}
    </>
  )
}
